import { preloadSyncedBlocksData } from './preloadSyncedBlocksData.ts';

const MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/editor/syncedBlocksData';

/**
 * Preloads synced blocks data for the editor and stores it in the window object for hydration.
 *
 * This is a convenience wrapper around the generic preloadSyncedBlocksData function,
 * providing editor-specific defaults.
 *
 * @param contentId - The ID of the content to preload synced blocks for
 * @param cloudId - The cloud ID associated with the content
 * @param isBlog - Whether the content is a blog post
 * @returns Promise that resolves when synced blocks data is preloaded
 */
export async function preloadEditorSyncedBlocksData(
	contentId: string | null,
	cloudId?: string,
	isBlog?: boolean,
): Promise<void> {
	if (!contentId || !cloudId || typeof isBlog === 'undefined') {
		return;
	}

	return preloadSyncedBlocksData({
		contentId,
		cloudId,
		isBlog,
		measureSegment: MEASURE_SEGMENT,
	});
}
